/**
=========================================================
* Material Dashboard 2 React - Orders Overview Section
=========================================================

* Modernisé pour cohérence SaaS :
  - Liste verticale d'événements
  - Design arrondi et espacé
*/

import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Composants internes
import TimelineItem from "examples/Timeline/TimelineItem";

function OrdersOverview() {
  return (
    <Card sx={{ borderRadius: 3, padding: 3 }}>
      <MDBox mb={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Orders overview
        </MDTypography>
        <MDTypography variant="button" color="text" fontWeight="regular">
          <MDBox component="span" color="success" fontWeight="bold">
            +30%
          </MDBox>{" "}
          this month
        </MDTypography>
      </MDBox>
      <MDBox>
        <TimelineItem
          color="success"
          icon="notifications"
          title="$2400, Design changes"
          dateTime="22 DEC 7:20 PM"
        />
        <TimelineItem
          color="error"
          icon="inventory_2"
          title="New order #1832412"
          dateTime="21 DEC 11 PM"
        />
        <TimelineItem
          color="info"
          icon="shopping_cart"
          title="Server payments for April"
          dateTime="21 DEC 9:34 PM"
        />
        <TimelineItem
          color="warning"
          icon="credit_card"
          title="New card added for order #4395133"
          dateTime="20 DEC 2:20 AM"
        />
        <TimelineItem
          color="primary"
          icon="key"
          title="Unlock packages for development"
          dateTime="18 DEC 4:54 AM"
        />
        <TimelineItem
          color="dark"
          icon="payments"
          title="New order #9583120"
          dateTime="17 DEC"
          lastItem
        />
      </MDBox>
    </Card>
  );
}

export default OrdersOverview;
